// src/api/org/service.js
import { json } from "utils/http/client";

export const WorkersApi = {
  // list worker attendance by date
  listWorkerAttendanceByDate: (data) =>
    json(`/worker/all-workers-attendance-history/`, {
      method: "POST",
      body: data,
    }),
  //list all worker attendance
  listAllWorkerAttendance: ({site_id}) =>
    json(`/worker/list-all-attendance/?site_id=${site_id}`, {
      method: "GET",
    }),

  //list all workers of a site
  listAllWorkers: (data) =>
    json(`/worker/get-workers-of-a-site-by-type/`, {
      method: "POST",
      body: data,
    }),
};
